import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api, formatError } from "@/lib/api";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) return setErr("Passwords do not match.");
    setErr(""); setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success("Password updated — sign in with your new password.");
      nav("/login");
    } catch (e2) {
      setErr(formatError(e2.response?.data?.detail) || "Reset failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white flex items-center justify-center p-6">
      <form onSubmit={submit} className="w-full max-w-sm" data-testid="reset-password-form">
        <Link to="/" className="flex items-center gap-2 mb-8">
          <img src="/brand/ptiq-icon.png" alt="ProTradeIQ" className="h-6 w-6 object-contain" />
          <span className="font-heading text-xl font-black uppercase">PROTRADE<span className="text-[#007AFF]">IQ</span></span>
        </Link>
        <div className="border border-zinc-800 bg-[#121212] p-6">
          <div className="inline-flex items-center justify-center w-10 h-10 border border-zinc-800 mb-4">
            <KeyRound className="h-4 w-4 text-[#007AFF]" />
          </div>
          <h1 className="font-heading text-xl font-bold uppercase tracking-tight">Set a new password</h1>
          {!token && <p className="mt-2 text-sm text-[#EF4444]">Missing reset token — use the exact link you were sent.</p>}
          <label className="text-xs uppercase tracking-widest text-zinc-400 mt-5 block">New password</label>
          <input value={pw} onChange={(e) => setPw(e.target.value)} required minLength={6} type="password"
                 className="mt-1 w-full bg-transparent border border-zinc-800 focus:border-[#007AFF] outline-none px-3 py-3 font-mono text-sm"
                 data-testid="reset-password-input" />
          <label className="text-xs uppercase tracking-widest text-zinc-400 mt-4 block">Confirm password</label>
          <input value={pw2} onChange={(e) => setPw2(e.target.value)} required minLength={6} type="password"
                 className="mt-1 w-full bg-transparent border border-zinc-800 focus:border-[#007AFF] outline-none px-3 py-3 font-mono text-sm"
                 data-testid="reset-password-confirm" />
          {err && <div className="mt-4 text-sm text-[#EF4444] border border-[#EF4444]/30 bg-[#EF4444]/5 px-3 py-2" data-testid="reset-password-error">{err}</div>}
          <button disabled={busy || !token || pw.length < 6} type="submit"
                  className="mt-6 w-full bg-[#007AFF] text-white font-bold uppercase tracking-wider py-3 hover:bg-[#3395FF] transition-colors disabled:opacity-50"
                  data-testid="reset-password-submit">
            {busy ? "Saving…" : "Update password"}
          </button>
        </div>
      </form>
    </div>
  );
}
